import {ICustomOptr} from '@syncfusion/ej2-grids/src/grid/base/interface';


export const DefaultTranslatedFilters: ICustomOptr = {
  stringOperator: [
    { text:"Égal",value:"Equal"},
    { text:"Différent de", value:"NotEqual"},
    { text:"Commence par",value:"StartsWith"},
    { text:"Finit par",value:"EndsWith"},
    { text:"Contient",value:"Contains"},
  ],
  booleanOperator: [
    {text: "Égal", value: "Equal"},
    {text: "Différent", value: "NotEqual"}
  ],
  numberOperator: [
    { text:"Égal",value:"Equal"},
    {text: "Strictement supérieur à", value: "GreaterThan"},
    {text: "Supérieur ou égal à", value: "GreaterThanOrEqual"},
    {text: "Strictement inférieur à", value: "LessThan"},
    {text: "Inférieur ou égal à", value: "LessThanOrEqual"},
    { text:"Différent de", value:"NotEqual"},
  ],
  dateOperator: [
    { text:"Égal",value:"Equal"},
    {text: "Après le", value: "GreaterThan"},
    {text: "Avant le", value: "LessThan"}
  ]
}
